import type { TourConfig } from '../../types/tour.types'

const myListsTour: TourConfig = {
  id: 'my-lists',
  title: 'Manage your lists',
  module: 'Lists',
  routeName: 'MyLists',
  order: 5,
  autoStart: true,
  steps: [
    {
      id: 'intro',
      title: 'Everything you saved, in one place',
      body: 'My Lists is your working memory — the companies and contacts you saved from searches, ready to act on. Come back here to pick up a campaign instead of rebuilding a list from scratch.',
    },
    {
      id: 'tabs',
      target: '.tabs-card',
      placement: 'bottom',
      title: 'Company, Contact & Ignored lists',
      body: 'Three kinds of list live here:\n- **Company lists** — accounts you saved to work\n- **Contact lists** — the specific people to reach\n- **Ignored lists** — companies you\'ve excluded, so they stay out of future results',
    },
    {
      id: 'table',
      target: '[data-tour="mylists-table"]',
      placement: 'top',
      title: 'Your saved lists',
      body: 'Each row is a saved list with its size and when it was created. Use the date filter to find an older one, and open any list to keep working it.',
    },
    {
      id: 'actions',
      target: '.actions-cell',
      placement: 'start',
      optional: true,
      title: 'Act on any list',
      body: 'On each list you can:\n- **View** — open it to see and work the records\n- **Export** — download it or push it straight to your CRM\n- **Actions ▸ Rename** — give it a clearer name\n- **Actions ▸ Delete** — remove it when you\'re done',
    },
  ],
}

export default myListsTour
